import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as impactsServiceClear } from './impactsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'impacts',
  serviceTableName: 'impactsService',
  serviceClearFunction: impactsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.impact]),
});
